import React from "react"

import {
  Container,
  Box,
  Button,
  Typography,
  // Customizable Area Start
  LinearProgress,
  Divider,
  ListItem,
  List,
  // Customizable Area End
  Link,
} from "@mui/material"

// Customizable Area Start
import {
  uploadIcon,
  successIcon,
  plusIcon,
} from "../../customisableuserprofiles/src/assets"
import PauseCircleOutlineIcon from "@mui/icons-material/PauseCircleOutline"
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined"
import PlayCircleFilledWhiteOutlinedIcon from "@mui/icons-material/PlayCircleFilledWhiteOutlined"
import DeleteModal from "../../../components/src/DeleteModal.web"
import CommonModal from "../../customisableuserprofiles/src/CommonModal"
import { withStyles } from "@mui/styles"

import { StyledEngineProvider } from "@mui/material/styles"

const BorderLinearProgress = withStyles({
  root: {
    height: 10,
    borderRadius: 5,
  },
  colorPrimary: {
    backgroundColor: "#F1F5F9",
  },
  bar: {
    borderRadius: 5,
    backgroundColor: "#94A3B8",
  },
})(LinearProgress)
// Customizable Area End

import BulkUploadingController, {
  Props,
  configJSON,
  baseURL,
} from "./BulkUploadingController"
export default class BulkUploading extends BulkUploadingController {
  constructor(props: Props) {
    super(props)
    // Customizable Area Start
    // Customizable Area End
  }

  // Customizable Area Start
  // Customizable Area End

  render() {
    return (
      // Customizable Area Start
      <StyledEngineProvider>
        <Box
          sx={{
            ...webStyle.profilePortfolioPlus,
          }}
          onClick={this.handleNewPortfolioModalOpen}
        >
          <Box
            sx={{ height: "60px", width: "60px" }}
            data-test-id="newPortfolioAddBtn"
            component="img"
            src={plusIcon}
            alt="plus-icon"
          />
        </Box>
        <CommonModal
          data-test-id="handleNewPortfolioPhoto"
          open={this.state.isUploadPortfolioOpen}
          onClose={this.handlePortfolioClose}
          title={"Upload Media"}
        >
          <Box sx={{ ...webStyle.browsePicModalInsideCon }}>
            <Box
              onDrop={this.handleFileDrop}
              onDragOver={this.handleDragOver}
              sx={{ ...webStyle.dragDropArea }}
              data-test-id="dragDropArea"
            >
              <img src={uploadIcon} />
              <Typography
                component={"h4"}
                sx={{ ...webStyle.profilePicModalHeading }}
              >
                Drag your file(s) to start uploading
              </Typography>
            </Box>
            <Divider>
              <Box sx={{ ...webStyle.uploadORText }}> or </Box>
            </Divider>
            <Box sx={{ ...webStyle.profilePicModalBotton }}>
              <input
                type="file"
                accept="image/*,video/*,audio/*,application/pdf"
                onChange={this.handlebrowseFileChange}
                style={{ display: "none" }}
                id="browse-portfolio"
                data-test-id="fileInputs"
                multiple
              />
              <Button
                sx={{ ...webStyle.profilePicModalDelete }}
                component="label"
                htmlFor="browse-portfolio"
              >
                Browse
              </Button>
            </Box>
          </Box>
          <Box sx={{ ...webStyle.uploadPortfolioModalInsideCon }}>
            <Typography sx={{ ...webStyle.fileTypeText }}>
              Only support .JPG, .PNG, .SVG, MP4, AVI, MP3 and PDF files.
            </Typography>
            <Typography sx={{ ...webStyle.fileTypeMaxText }}>
              (The maximum file size for photos is 10MB and videos is 100MB)
            </Typography>
            {this.state.validPortfolioError.length > 0 && (
              <List
                sx={{ ...webStyle.errorMessage }}
                data-test-id="portfolio-error-list"
              >
                {this.state.validPortfolioError.map(
                  (error: string, index: number) => (
                    <ListItem
                      data-test-id={`portfolio-error-item-${index}`}
                      key={index}
                      sx={{ color: "red" }}
                    >
                      {error}
                    </ListItem>
                  )
                )}
              </List>
            )}
          </Box>
          {this.state.isUploading && (
            <Box
              sx={{ ...webStyle.uploadBelowText }}
              data-test-id="uploadProgress"
            >
              <Typography sx={{ ...webStyle.uploadText }}>
                Uploading...
              </Typography>
              <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                <Typography
                  sx={{ ...webStyle.fileTypeMaxText }}
                  data-test-id="uploadProgressText"
                >
                  {this.progressCheck(this.state.progress).toFixed(0)}% •{" "}
                  {this.state.remainingTime.toFixed(0)} seconds remaining
                </Typography>
                <Box>
                  {this.state.isPaused ? (
                    <PlayCircleFilledWhiteOutlinedIcon
                      style={{ color: "#94A3B8", cursor: "pointer" }}
                      onClick={this.resumeUpload}
                      data-test-id="resumeUploadBtn"
                    />
                  ) : (
                    <PauseCircleOutlineIcon
                      style={{ color: "#94A3B8", cursor: "pointer" }}
                      onClick={this.pauseUpload}
                      data-test-id="pauseUploadBtn"
                    />
                  )}
                  <CancelOutlinedIcon
                    style={{ color: "#F87171", cursor: "pointer" }}
                    onClick={this.cancelUpload}
                    data-test-id="cancelUploadBtn"
                  />
                </Box>
              </Box>
              <BorderLinearProgress
                variant="determinate"
                value={this.state.progress}
              />
            </Box>
          )}
        </CommonModal>

        <DeleteModal
          open={this.state.isMediaUploadSuccessModalOpen}
          onClose={() =>
            this.setState({ isMediaUploadSuccessModalOpen: false })
          }
          title={""}
        >
          <Box sx={{ ...webStyle.deletePortfolioModalInsideCon }}>
            <img src={successIcon} style={{ marginBottom: "30px" }} />
            <Typography
              component={"h4"}
              sx={{ ...webStyle.deletePortfolioModalHeading }}
            >
              Media Uploaded Successfully!
            </Typography>
            <Typography sx={{ ...webStyle.deletePortfolioModalDesc }}>
              Your media files have been added to your portfolio.
            </Typography>
          </Box>
        </DeleteModal>
      </StyledEngineProvider>
      // Customizable Area End
    )
  }
}

// Customizable Area Start
const webStyle = {
  profilePortfolioPlus: {
    border: "1px dashed #94A3B8",
    cursor: "pointer",
    position: "relative",
    width: "100%",
    maxWidth: "300px",
    aspectRatio: "268 / 316", 
    borderRadius: "10px",
    overflow: "hidden",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    ":hover": { backgroundColor: "rgba(0, 0, 0, 0.02)" },
    ["@supports not (aspect-ratio: 1)"]: {
      height: 0,
      paddingBottom: "117.91%",
    },
  },
  browsePicModalInsideCon: {
    gap: "20px",
    margin: "30px",
    padding: "30px",
    display: "flex",
    flexDirection: "column",
    border: "1px dashed #94A3B8",
    borderRadius: "20px",
    "@media (max-width: 550px)": {
      padding: "15px",
      margin: "15px 0px 0px 0px",
    },
  },
  dragDropArea: {
    padding: "20px",
    textAlign: "center",
  },
  uploadPortfolioModalInsideCon: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  uploadBelowText: {
    border: "1px solid #CBD5E1",
    borderRadius: "12px",
    padding: "30px",
    margin: "30px",
  },
  uploadText: {
    fontSize: "14px",
    fontWeight: "600",
    color: "#0F172A",
  },
  fileTypeText: {
    fontSize: "14px",
    fontWeight: "400",
    letterSpacing: "-0.15px",
    color: "#64748B",
    fontFamily: "Montserrat !important",
  },
  fileTypeMaxText: {
    fontSize: "14px",
    fontWeight: "300",
    letterSpacing: "-0.15px",
    color: "#64748B",
    fontFamily: "Montserrat !important",
  },
  errorMessage: {
    fontSize: "14px",
    fontWeight: "400",
    lineHeight: "6px",
    color: "#E11B23",
    marginTop: "15px",
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
  },
  uploadORText: {
    fontSize: "14px",
    fontWeight: "500",
    lineHeight: "24px",
    color: "#64748B",
    fontFamily: "Montserrat !important",
  },
  profilePicModalHeading: {
    fontSize: "16px",
    fontWeight: "500",
    lineHeight: "19.5px",
    color: "#0F172A",
    marginTop: "20px",
    "@media (max-width: 414px)": {
      fontSize: "12px",
      lineHeight: "15px",
    },
    "@media (min-width: 415px) and (max-width: 1280px)": {
      fontSize: "14px",
      lineHeight: "17px",
    },
    "@media (min-width: 1600px)": {
      fontSize: "18px",
      lineHeight: "21px",
    },
  },
  deletePortfolioModalInsideCon: {
    padding: "30px",
    borderRadius: "20px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    "@media (max-width: 550px)": {
      padding: "15px",
      margin: "15px 0px 0px 0px",
    },
  },
  profilePicModalBotton: {
    display: "flex",
    gap: "8px",
    alignItems: "center",
    justifyContent: "center",
  },
  input: {
    fontSize: "16px",
    lineHeight: "24px",
    color: "#64748b !important",
    opacity: "1 !important",
    "& .MuiOutlinedInput-root": {
      borderRadius: "50px",
      borderColor: "#e2e8f0",
      "&:hover": { borderColor: "#cbd5e1" },
      "&.Mui-focused": {
        borderColor: "#673ab7",
        boxShadow: "0 0 0 3px rgba(103, 58, 183, 0.2)",
      },
    },
  },
  profilePicModalDelete: {
    fontSize: "14px !important",
    fontWeight: 600,
    width: "140px !important",
    color: "#652784 !important",
    lineHeight: "24px !important",
    borderRadius: "32px",
    padding: "10px 39px !important",
    border: "2px solid transparent !important",
    background:
      "linear-gradient(to right, white, white), linear-gradient(90deg, #8077FF 0%, #652784 60%)",
    backgroundClip: "padding-box, border-box",
    backgroundOrigin: "padding-box, border-box",
    textTransform: "none",
    cursor: "pointer",
    "@media (max-width: 1280px)": {
      fontSize: "12px",
    },
  },
  deletePortfolioModalDesc: {
    fontWeight: "400",
    fontSize: "16px",
    color: "#64748B",
    display: "flex",
    lineHeight: "22px",
    textAlign: "center",
    justifyContent: "center",
    "@media (max-width: 414px)": {
      lineHeight: "13px",
      fontSize: "10px",
    },
    "@media (min-width: 415px) and (max-width: 1280px)": {
      lineHeight: "15px",
      fontSize: "12px",
    },
    "@media (min-width: 1600px)": {
      lineHeight: "19px",
      fontSize: "16px",
    },
  },
  deletePortfolioModalHeading: {
    fontWeight: "600",
    fontSize: "28px",
    lineHeight: "32px",
    color: "#0F172A",
    marginBottom: "10px",
    "@media (max-width: 414px)": {
      fontSize: "12px",
      lineHeight: "15px",
    },
    "@media (min-width: 415px) and (max-width: 1280px)": {
      fontSize: "14px",
      lineHeight: "17px",
    },
    "@media (min-width: 1600px)": {
      fontSize: "18px",
      lineHeight: "21px",
    },
  },
}
// Customizable Area End
